/**
 * Outlined "user with a checkmark" icon (16px, grey) used to denote a submission
 * marked as submitted by the user (e.g. the submitted state shown in the Auth
 * Status column). Distinct from {@link UserCheckIcon}, which is a larger green
 * variant used on the submission-status banner.
 *
 * @param props.width - SVG width (defaults to `16`).
 * @param props.height - SVG height (defaults to `16`).
 * @param props.stroke - Stroke color for the glyph (defaults to grey `#999999`).
 * @returns The rendered user-check SVG icon.
 */
const UserCheck16Icon = (props: {
  width?: string;
  height?: string;
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "16"}
    height={props.height || "16"}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.0026 10.3333H5.00261C4.07223 10.3333 3.60704 10.3333 3.22851 10.4482C2.37624 10.7067 1.7093 11.3736 1.45076 12.2259C1.33594 12.6044 1.33594 13.0696 1.33594 14M10.6693 12L12.0026 13.3333L14.6693 10.6667M9.66927 5C9.66927 6.65685 8.32612 8 6.66927 8C5.01242 8 3.66927 6.65685 3.66927 5C3.66927 3.34315 5.01242 2 6.66927 2C8.32612 2 9.66927 3.34315 9.66927 5Z"
      stroke={props.stroke || "#999999"}
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserCheck16Icon;
